import { Component, ChangeDetectionStrategy, Input, OnChanges, ChangeDetectorRef } from '@angular/core';
import { Ticket } from 'api/ticketing.api';

@Component({
    selector: 'ce-ticket-badge',
    templateUrl: './ticket-badge.component.html',
    styleUrls: ['./ticket-badge.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TicketBadgeComponent implements OnChanges {
    @Input() ticket: Ticket;
    constructor(private cdRef: ChangeDetectorRef) {}

    ngOnChanges() {
        this.cdRef.markForCheck();
    }
}
